import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { Banner } from '@shared/design-system/ui'
import { useFeatureFlag } from '@shared/feature-flags/useFeatureFlag'
import { useSession } from '@shared/lib/auth/session-store'
import { CrmWebhookPanel } from '@features/admin/ui/CrmWebhookPanel'
import { actionLink, page, subtitle, title } from './ConfigPage.css'

export function CrmIntegrationPage() {
  const enabled = useFeatureFlag('crmIntegration')
  const isSuper = useSession((state) => state.user?.isSuper === true)

  return (
    <section className={page} data-testid="crm-integration-page">
      <Link to="/config" className={actionLink}>
        <ArrowLeft size={16} />
        Voltar às configurações
      </Link>
      <div>
        <h1 className={title}>Integração com o CRM</h1>
        <p className={subtitle}>
          Envie dados cadastrais e a situação operacional dos vendedores ao CRM de suporte.
        </p>
      </div>
      {enabled ? (
        <CrmWebhookPanel isSuper={isSuper} />
      ) : (
        <Banner tone="info" title="Integração indisponível">
          A conexão com o CRM não está disponível no momento.
        </Banner>
      )}
    </section>
  )
}
